var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[('login' == _vm.$route.name)?_c('Login'):_vm._e(),('reset' == _vm.$route.name)?_c('ResetPassword'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }